import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { SquareStackIcon, TrashIcon } from '@/icons';
import { ContextMenu } from '@/ui_v3';
export const WithSliderItemContextMenu = ({
  children,
  onCopy,
  onDelete,
  disabled
}: {
  children: React.ReactNode;
  onCopy: () => void;
  onDelete: () => void;
  /** AI 작업의 원본 카드면 끝날 때까지 복제·삭제를 잠근다(카드 헤더·drawer 와 같은 규칙). */
  disabled?: boolean;
}) => {
  const iconFill = disabled ? ICON_COLOR.disabled : ICON_COLOR.default;
  const {
    t
  } = useTranslation(['common']);
  return <ContextMenu.Root modal={false} data-sentry-element="unknown" data-sentry-component="WithSliderItemContextMenu" data-sentry-source-file="WithSliderItemContextMenu.tsx">
      <ContextMenu.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">{children}</ContextMenu.Trigger>
      <ContextMenu.Portal data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
        <ContextMenu.Content data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
          <ContextMenu.Item disabled={disabled} onSelect={() => {
          // 메뉴 래퍼가 disabled 를 primitive 에 넘기지 않아도 키보드 선택으로 새지 않게 막는다.
          if (disabled) return;
          onCopy();
          logger.track('copy_quizItem', {
            position: 'sidebar_context_menu'
          });
        }} data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
            <SquareStackIcon size="sm" fill={iconFill} data-sentry-element="SquareStackIcon" data-sentry-source-file="WithSliderItemContextMenu.tsx" />
            {t('global.duplicate.button')}
          </ContextMenu.Item>
          <ContextMenu.Item disabled={disabled} onSelect={() => {
          if (!disabled) onDelete();
        }} data-sentry-element="unknown" data-sentry-source-file="WithSliderItemContextMenu.tsx">
            <TrashIcon size="sm" fill={iconFill} data-sentry-element="TrashIcon" data-sentry-source-file="WithSliderItemContextMenu.tsx" />
            {t('global.delete')}
          </ContextMenu.Item>
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>;
};